import { h, defineComponent, VNodeChildren } from 'vue';

export type ContainerSize =
  'small'
  | 'narrow'
  | 'default'
  | 'medium'
  | 'large'
  | 'x-large'
  | 'is-fluid';

export interface ContainerProps {
  size: ContainerSize;
}

export const Container = defineComponent<ContainerProps>({
  name: 'Container',
  props: ['size'],
  setup(props, context) {
    return function render() {
      return h('div', { class: ['container', props.size] }, context.slots.default?.());
    };
  },
});

export function container(contents: VNodeChildren, size: ContainerSize = 'default', classes?: string) {
  return h(Container, { class: classes, props: { size } }, contents);
}
